import { render, staticRenderFns } from "./UpdateTagDialog.vue?vue&type=template&id=1746fdfa&scoped=true"
import script from "./UpdateTagDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTagDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateTagDialog.vue?vue&type=style&index=0&id=1746fdfa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746fdfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1746fdfa')) {
      api.createRecord('1746fdfa', component.options)
    } else {
      api.reload('1746fdfa', component.options)
    }
    module.hot.accept("./UpdateTagDialog.vue?vue&type=template&id=1746fdfa&scoped=true", function () {
      api.rerender('1746fdfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/tag/dialog/UpdateTagDialog.vue"
export default component.exports